<span class="trigger-shell">
    <button
        #triggerButton
        #filterTrigger="cdkOverlayOrigin"
        cdkOverlayOrigin
        qpxButton
        [matButton]="appearance()"
        matBadge="•"
        matBadgeColor="accent"
        matBadgeSize="small"
        [matBadgeHidden]="!hasVisibleActiveFilters()"
        size="sm"
        class="filter-row-control"
        [class.icon-only]="showIconOnly()"
        [qpxTooltip]="triggerTooltip()"
        [matTooltipDisabled]="
            !(disabled() && disabledReason()) && !showIconOnly()
        "
        [disabled]="disabled()"
        [disabledInteractive]="disabled()"
        [attr.aria-describedby]="
            disabled() && disabledReason() ? disabledReasonId : null
        "
        [attr.aria-controls]="surfaceId"
        [attr.aria-expanded]="isOpen()"
        [attr.aria-label]="triggerAriaLabel()"
        aria-haspopup="dialog"
        (click)="toggle()"
    >
        <ng-icon qpx name="lucideSettings2" matButtonIcon />
        @if (!showIconOnly()) {
            <span class="filter-row-control-label">{{ triggerLabel() }}</span>
        }
    </button>
    @if (disabled() && disabledReason()) {
        <span class="sr-only" [id]="disabledReasonId">
            {{ disabledReason() }}
        </span>
    }
</span>

<div #workspaceContent class="projected-content-host">
    <ng-content />
</div>

<ng-template
    #filterOverlay="cdkConnectedOverlay"
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="isOpen() && !isMobile()"
    [cdkConnectedOverlayOrigin]="filterTrigger"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayGrowAfterOpen]="true"
    [cdkConnectedOverlayViewportMargin]="popoverViewportMargin"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="dismissPopover()"
    (overlayKeydown)="onOverlayKeydown($event)"
    (detach)="onDetach()"
>
    <qpx-filter-workspace-surface
        appearance="popover"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true"
        [content]="contentPortal()"
        [controller]="controller()"
        [dialogLabel]="dialogLabel()"
        [hiddenDimensionKeys]="hiddenDimensionKeys()"
        [surfaceId]="surfaceId"
        [triggerLabel]="triggerLabel()"
        (applied)="applyPopover()"
        (dismissed)="dismissPopover()"
    />
</ng-template>
